// Get Dashboard
export const GET_DASHBOARD_REQUEST = 'GET_DASHBOARD_REQUEST';
export const GET_DASHBOARD_DONE = 'GET_DASHBOARD_DONE';
export const GET_DASHBOARD_FAILED = 'GET_DASHBOARD_FAILED';

// Set Dashboard Popup
export const SET_DASHBOARD_POPUP = 'SET_DASHBOARD_POPUP';
export const CLEAR_DASHBOARD_POPUP = 'CLEAR_DASHBOARD_POPUP';